<h4>Select how you&rsquo;d like to accept bookings and check-ins for CurbNTurfers.</h4>
<curbnturf-booking-form [form]="form"></curbnturf-booking-form>
<p class="booking-spacing">
  Selecting "Allow Instant Bookings" enables you to have a "Minimum request notice" of less then 24 hours.
</p>
